import { lazy } from '@/service/lazy'

export default [{
  name: 'CampanhasSiape',
  path: 'campanhasiape',
  id: 'campanhasiape',
  icon: 'fa fa-list',
  component: lazy('app/default/listagem/index'),
  meta: { requireAuth: true, rules: ['gerenciar_lista'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/listagemSiape.js